<!-- SMT 配送方式 -->
<template>
  <div class="smt-gain_order_type">
    <BaseFormItem :label="fields.label">
      <BaseRadioGroup v-model="val" @change="handleEmit">
        <template v-for="item in fields.options">
          <el-tooltip popper-class="popper-new-address" content="我司华南工厂搬迁，请注意到新地址自提" placement="top" effect="light" v-if="item.value == 1">
            <el-radio-button
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio-button>
          </el-tooltip>
          <el-radio-button
            v-else
            :key="item.value"
            :label="item.value"
          >{{ item.label }}</el-radio-button>
        </template>
      </BaseRadioGroup>
    </BaseFormItem>
    <template v-if="val == 1">
      <BaseFormItem label="提货地址">
        <div class="smt-gain_order_type__address">
          <p>华南工厂：广东省江门市江海区江睦路156号4楼华秋元器件仓<img src="@@/assets/img/common/new-address.png" class="new-address-img"/></p>
          <p>华中工厂：湖南省长沙市望城区航空路6号手机智能终端产业园2栋3楼仓库办公室</p>
          <p>实际提货地址以<span>最终分配</span>的生产工厂为准</p>
        </div>
      </BaseFormItem>
      <BaseFormItem label="提货时间">
        <div class="smt-gain_order_type__time">
          <span>周一至周五  15:00-18:30</span>
          <i>请提前一天与客服沟通确认自提时间</i>
        </div>
      </BaseFormItem>
    </template>
  </div>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getSMTFields('gain_order_type')
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.smt-gain_order_type {
  .smt-gain_order_type__address {
    width: 730px;
    padding: 10px 13px;
    border-radius: 5px;
    background-color: $--background-hover;
    >p {
      line-height: 1;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
        font-size: 12px;
        color: $--color-text-placeholder;
        >span {
          color: $--color-warning;
        }
      }
    }
    .new-address-img {
      height: 16px;
    }
  }
  .smt-gain_order_type__time {
    width: 530px;
    padding: 12px 13px;
    line-height: 1;
    border-radius: 5px;
    background-color: #FDF6EC;
    >span {
      margin-right: 13px;
      color: $--color-warning;
    }
    >i {
      font-size: 12px;
      color: $--color-text-placeholder;
    }
  }
}
</style>
<style lang="scss">
.popper-new-address {
  color: #FF4D4F;
  border: 1px solid #FF4D4F!important;
  background: #FFF6F6!important;
  padding: 5px;
  .popper__arrow {
    border-top-color: #FF4D4F !important;
    &::after {
      border-top-color: #FFF6F6!important;
    }
  }
}
</style>